import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { enviroment } from 'src/environments/environment';
import { CreateTaskRequest } from '../model/request/createTaskRequest';
import { Observable, tap } from 'rxjs';
import { UpdateTaskRequest } from '../model/request/updateTaskRequest';
import { Events } from '../model/event';
import { CreateTaskResponse } from '../model/request/createTaskResponse';
import { ListEvents } from '../model/response/list-events-response';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  eventsUrl: string
  globalUrl: string = enviroment.BASE_URL_API + '/global'
  httpOptions: {};



  constructor(private http: HttpClient) {
    this.httpOptions = {};
    this.eventsUrl = enviroment.BASE_URL_API + '/event';

    let idToken = sessionStorage.getItem('idToken') || ""
    this.httpOptions = {
      headers: new HttpHeaders({  
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      })
    };


  }


  getEvent(status: string) : Observable<ListEvents> {
      let url = `${this.eventsUrl}`
      if(status !== "") {
        url = `${url}=?status=${status}`
      }
      return this.http.get<ListEvents>(url, this.httpOptions).pipe(
        tap()
      );
  }

  getEvents(): Observable<Events[]> {
    return this.http.get<Events[]>(this.eventsUrl, this.httpOptions).pipe(tap());
  }

  putEvent(id: string, event: Events): Observable<any> {
    return this.http.put<any>(`${this.eventsUrl}/${id}`, event, this.httpOptions).pipe(tap());
  }

  postEvent(event: Events): Observable<any> {
    return this.http.post<any>(`${this.eventsUrl}/`, event, this.httpOptions).pipe(tap());
  }

  deleteEvent(id: string): Observable<any> {
    return this.http.delete<any>(`${this.eventsUrl}/${id}`, this.httpOptions).pipe(tap());
  }

  getUserEvents(userId: string): Observable<Events[]> {
    return this.http.get<Events[]>(`${enviroment.BASE_URL_API}/user/${userId}/events`, this.httpOptions).pipe(tap());
  }

  getEventCheckins(eventId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.eventsUrl}/${eventId}/checkins`, this.httpOptions).pipe(tap());
  }

  checkinEvent(userId: string, eventId: string, qrCode: string, physicalPass: boolean = false): Observable<any> {
    const url = `${enviroment.BASE_URL_API}/user/${userId}/event/${eventId}/checkin?qrCode=${qrCode}&physicalPass=${physicalPass}`;
    return this.http.post<any>(url,  this.httpOptions).pipe(tap());
  }
  checkoutEvent(userId: string, eventId: string): Observable<any> {
    const url = `${enviroment.BASE_URL_API}/user/${userId}/event/${eventId}/checkout`;
    return this.http.post<any>(url,  this.httpOptions).pipe(tap());
  }

  getQuantityCheckins(eventId: string): Observable<any> {
    return this.http.get<any>(`${this.eventsUrl}/${eventId}/checkins`, this.httpOptions).pipe(tap());
  }
  

}
